import {
    // Button,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    makeStyles,
} from "@material-ui/core";
// import {
//     Add,
// } from "@material-ui/icons";
// import { showAddItemsDialog } from "../items-add/items-add-slice";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
    tableHeader: {
      background: "#111111",
      height: "100%",
      color: "#fbbbd3",
      fontSize: 14,
    },
    button: {
      background: "#111111",
      color: "#fbbbd3",
      justifyContent: "right"
    },
    buttonText: {
      color: "#111111",
    },
    title: {
      color:"#111111",
      marginBottom: 20,
    },
    typography: {
        color:"#111111",
    }
}));

const ForRentCostumesListEmpty = () => {
    const classes = useStyles();
    const dispatch = useDispatch();

    return (
        <>
            <Typography className={classes.title} variant="h4">For Rent Costumes</Typography>
            <div style={{ display: "center", alignItems: "center", marginTop: 10}}>
                <Typography className={classes.typography}>
                    No costumes found.
                </Typography>
            </div>
        </>
        
    );
};

export default ForRentCostumesListEmpty;